import React, { useState } from "react";
import { RunnerUpHeader } from "../../../ui";
import SelectField from "../../../library/components/Select/index";
import { useGetEpbDownloadStatewiseEciReportMutation,useGetStatesStatusForceWiseQuery } from "../../../services/reportsServices";
import "./countingsupervisoreciofficer.css";
import { Validators } from "../../../library/utilities/Validator";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const tableHeader = [
  "State Name",
  "AC/PC No. and Name",
  "Total e-PB Generated",
  "Total e-PB Downloaded",
  "Total e-PB Pending for Download",
];

const EpbDownloadingStatewiseEciReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const reportName = "e-Postal Ballot Downloading Report State Wise"
  const SheetName = "State Wise Report"

  const [Error, setError] = useState({});
  const { data: getElectionAnnouncedState } = useGetStatesStatusForceWiseQuery();
  const [tableData, setTableData] = useState([]);
  const stateList = [{value: "", label: " Select State" }];
  const constType = [
    { value: "", label: "Select Constituency" },
    { value: "AC", label: "AC" },
    { value: "PC", label: "PC" },
  ];
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "AC/PC No. and Name",
      accessor: "col2",
    },
    {
      Header: "Total e-PB Generated",
      accessor: "col3",
    },
    {
      Header: "Total e-PB Downloaded",
      accessor: "col4",
    },
    {
      Header: "Total e-PB Pending for Download",
      accessor: "col5",
    },
  ];
  columns.map((item)=>{
    tableHeader.push(item.Header)
  })
  const [states, setStates] = useState({
    stateValue:"",
    constTypeValue:"",
  });

  const [saveData, datap] = useGetEpbDownloadStatewiseEciReportMutation()

  getElectionAnnouncedState?.payload?.map((item) => {
    stateList?.push({
      value: item.stateCd,
      label: item.stateName,
    });
  });

  const handleChange = (key, value) => {
    setStates((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };

  const renderTableData = () => {
    let error = {};
    if (!states.stateValue || states.stateValue === "" || states.stateValue.length == 0) {
      error["stateValue"] = "This Field is required"
    }
    if (!states.constTypeValue || states.constTypeValue === "") {
      error["constTypeValue"] = "This Field is required"
    }
    if (Object.keys(error).length) {
      setError(error);
      return;
    }
    let payload = {
      "stateCd": states.stateValue,
      "constType": states.constTypeValue
    }
    saveData(payload)
      .unwrap()
      .then((res) => {
        let tData = []
        res?.payload?.map((item) => {
          tData.push({
            "col1": item.stateName,
            "col2": item.acPcNo && `${item.acPcNo}-${item.acPcName}`,
            "col3": item.uploadedEpbCount,
            "col4": item.downloadedEpbCount,
            "col5": item.pendingEpbCount,
          });
        });
        setTableData(tData)
        setTotalNoOfRecords(res?.payload?.length)
      }).catch((error) => {
        if(error?.data?.message==="No record found")
        {
          
          setTableData([])
        }
      })
  };
  return (
    <>
    <LeftMenu>
      <div className="container box shadow ">
      <div className="row">
          <div className="col-md-12">
            <RunnerUpHeaderNew title={reportName} 
            onPdfClick={() => downloadPdfFile(reportName, tableHeader, tableData , false, true)}
            onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tableData, true)}
            />
          </div>
        </div>
        <div className="row">
          <SelectField
          labelClass=""
          inputClass="col-md-4"
          options={stateList}
          name="stateValue"
          value={states.stateValue}
          handleChange={(val) => handleChange("stateValue", val)}
          validators={[
            {
              check: Validators.required,
              message: "This field is required",
            }
          ]}

          getError={(val) => getError("stateValue", val)}
          Error={Error}
        ></SelectField>
          <SelectField
            labelClass=""
            inputClass="col-md-2 pr-1"
            value={states.constTypeValue}
            name="constTypeValue"
            handleChange={(val) => handleChange("constTypeValue", val)}
            options={constType}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              }
            ]}
  
            getError={(val) => getError("constTypeValue", val)}
            Error={Error}
          />
          <div className="col-md-2 ">
          <button
              type="button"
              className="btn btn-primary btn-sm searchbuttonreport"
              onClick={renderTableData}>
              VIEW
              <span className="pl-2">
                <i class="fa fa-eye">
                </i>
              </span>
            </button>
          </div>
        </div>
        <div style={{marginTop:"-40px"}}>
        <Table
              placeholder="Search"
              globalsearch={true}
              selectall={true}
              columns={columns}
              emptyMessage="No Record Found"
              data={tableData?.length === 0 ? [] : tableData}
              size={5}
              tableClassNameCheck="contenttable-eroll"
              pagination  
              records
              gotopage
              rows
              numberrows={totalNoOfRecords}
            />
        </div>
      </div>
      </LeftMenu>
    </>
  );
};

export default EpbDownloadingStatewiseEciReport;
